import axios from "axios";
import Config from "src/config";

const v2_actionChatInternoEditarGrupo = (id, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chat-internal/${id}/editar-grupo`,
        data
    });
};
export default v2_actionChatInternoEditarGrupo;
